// Pola panelu administratora przechowują parametry sklepu (adres, miasto, telefon itp.),
// przez co przeglądarka rozpoznaje je jako formularz adresowy i po wyjściu ze strony
// proponuje zapisanie danych jako nowy adres dostawy. Poniższe atrybuty to blokują
// (autoComplete dla przeglądarek, pozostałe dla menedżerów haseł).
export const noAutofillProps = {
    autoComplete: 'off',
    'data-form-type': 'other',
    'data-lpignore': 'true',
    'data-1p-ignore': 'true'
}
